import request from '@/utils/request'

// 获取验证码--测试接口，无需token
export function getCodeImg () {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 获取用户详细信息
export function getInfo () {
  return request({
    url: '/auth/user/getInfoV2',
    method: 'get'
  })
}

// 登出
export function quitLogin () {
  return request({
    url: '/auth/user/logout',
    method: 'post',
    headers: {
      'device-type': '1',
    },
  })
}
